"use strict";
exports.__esModule = true;
exports.RequestHub = void 0;
var operators_1 = require("rxjs/operators");
var RequestHub = /** @class */ (function () {
    function RequestHub(id, responseObs, sendMessage, scheduler) {
        this.id = id;
        this.responseObs = responseObs;
        this.sendMessage = sendMessage;
        this.scheduler = scheduler;
        this.incrementingID = 0;
    }
    RequestHub.prototype.sendRequest = function (reqRes, args) {
        var _this = this;
        var msg = {
            id: this.getNextReqID(),
            name: reqRes.name,
            type: 'req',
            version: [0, 0, 0],
            payload: reqRes.codecs.req.encodeUnsafe(args),
            error: null
        };
        return new Promise(function (resolve, reject) {
            _this.sendMessage(msg);
            _this.responseObs
                .pipe((0, operators_1.first)(function (res) { return res.id === msg.id; }), (0, operators_1.timeout)(3000, _this.scheduler))
                .subscribe(function (res) {
                if (res.error === null) {
                    resolve(reqRes.codecs.res.decodeUnsafe(res.payload));
                }
                else {
                    var error = new Error(res.payload);
                    error.name = res.error;
                    reject(error);
                }
            }, function (err) {
                reject(err);
            });
        });
    };
    RequestHub.prototype.getNextReqID = function () {
        return this.id + "-" + this.incrementingID++;
    };
    return RequestHub;
}());
exports.RequestHub = RequestHub;
//# sourceMappingURL=RequestHub.js.map